module.exports = __webpack_public_path__ + "img/compass.7a13eab6.svg";